import React from "react";
import { Box, Paper, Skeleton, Typography } from "@mui/material";
import ModuleIconBadge from "../ModuleIconBadge";

/**
 * One headline figure - a count, total or status - with its label and an
 * optional hint underneath. `moduleKey` picks the badge (and so the colour)
 * from constants/moduleVisuals.js. `loading` keeps the card's size while the
 * figure is fetched.
 */
export default function StatCard({ moduleKey, label, value, hint, loading }) {
  return (
    <Paper
      sx={{
        p: 2,
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        minWidth: 0,
        height: "100%",
      }}
    >
      {moduleKey && <ModuleIconBadge moduleKey={moduleKey} size="md" />}
      <Box sx={{ minWidth: 0 }}>
        <Typography
          variant="body2"
          color="text.secondary"
          noWrap
          sx={{ fontWeight: 600 }}
        >
          {label}
        </Typography>
        {loading ? (
          <Skeleton width={64} height={32} />
        ) : (
          <Typography
            sx={{
              fontSize: "1.375rem",
              fontWeight: 700,
              lineHeight: 1.3,
              fontVariantNumeric: "tabular-nums",
            }}
          >
            {value ?? "-"}
          </Typography>
        )}
        {hint && (
          <Typography variant="body2" color="text.disabled" noWrap>
            {hint}
          </Typography>
        )}
      </Box>
    </Paper>
  );
}
